import { all, takeLatest, call, put, select } from 'redux-saga/effects';

import {
  types,
  fetchQuestionQuotaSuccess,
  fetchQuestionQuotaFailed,
} from '@coconut/services/redux/questionQuota';
import { getUserId } from '@coconut/services/redux/profile';

import * as apis from '@coconut/services/apis/questionQuota';

import { UNLIMITED_QUOTA } from '@coconut/constants/questionQuota';
import { QA, TIME_BASED } from '@coconut/constants/quotaType';
import { FREE } from '@coconut/constants/consumerTypes';

function* fetchQuestionQuotaFlow() {
  const userId = yield select(getUserId);

  try {
    const {
      data: {
        question_quota_types: quotaTypes = [],
        consumer_type: consumerType,
      },
    } = yield call(apis.fetchQuestionQuotaApi, userId);

    const isPaidUser = consumerType !== FREE;

    const quotas = quotaTypes.reduce((acc, cur) => {
      const {
        available_quotas: availableQuotas,
        teaching_method: method,
        has_unlimited: hasUnlimited,
      } = cur;

      if (!acc[method]) {
        acc[method] = 0;
      }

      const quota = hasUnlimited ? UNLIMITED_QUOTA : availableQuotas;
      acc[method] += quota;
      return acc;
    }, {});

    yield put(
      fetchQuestionQuotaSuccess({
        qaQuota: quotas[QA] || 0,
        writingQuota: quotas[TIME_BASED] || 0,
        isPaidUser,
      })
    );
  } catch (err) {
    yield put(fetchQuestionQuotaFailed(err.message));
  }
}

export default function* () {
  yield all([takeLatest(types.FETCH_QUESTION_QUOTA, fetchQuestionQuotaFlow)]);
}



// WEBPACK FOOTER //
// ./src/services/sagas/questionQuota.js